import React from 'react';

import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import InputField from 'src/presentation/components/forms/InputField';
import { FIELD_MAPPER } from '../ThreadsConstants';
import { FirstColumn, SecondColumn, ThreadSection } from 'src/presentation/components/pages/threads/ThreadsLayouts';
import LanguagesDropdown from 'src/presentation/components/pages/shared/LanguageDropdown';

const MainSection = () => (
  <>
    <FirstColumn>
      <ThreadSection>
        <CustomRow>
          <InputField
            attr={FIELD_MAPPER.NAME.path}
            data-aid={FIELD_MAPPER.NAME.path}
            description={FIELD_MAPPER.NAME.description}
            label={FIELD_MAPPER.NAME.label}
            placeholder={FIELD_MAPPER.NAME.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <LanguagesDropdown attr={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_ANSWER_LANGUAGE.path} />
        </CustomRow>
      </ThreadSection>
    </FirstColumn>
    <SecondColumn></SecondColumn>
  </>
);

export default MainSection;
